import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import { cn } from '@/shared/lib/utils';

const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitive.Root>, React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>>(
    function Slider({ className, defaultValue, value, ...props }, ref) {
        return (
            <SliderPrimitive.Root
                ref={ref}
                className={cn('relative -my-2 flex w-full touch-none select-none items-center py-2 cursor-pointer', className)}
                defaultValue={defaultValue}
                value={value}
                {...props}
            >
                <SliderPrimitive.Track className="relative h-1 w-full grow overflow-hidden rounded-full bg-[#454545]">
                    <SliderPrimitive.Range className="absolute h-full bg-[#2D8CEB]" />
                </SliderPrimitive.Track>
                <SliderPrimitive.Thumb className="block h-2 w-2 rounded-full border border-white/35 bg-white shadow-[0_1px_3px_rgba(0,0,0,0.35)] transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent disabled:pointer-events-none disabled:opacity-50" />
            </SliderPrimitive.Root>
        );
    },
);

export { Slider };